<template>
  <transition
    appear
    name="custom-classes-transition"
    enter-active-class="animated fadeIn faster"
    leave-active-class="animated fadeOut faster"
  >
    <popup v-if="show">
      <div class="ui-message-tips">
        <div class="ui-content">
          <img
            class="close"
            @click="onClose"
            :src="`${$cdn}images/close@2x.png`"
            alt
          />
          <h1>留言</h1>
          <div class="content">
            <div class="textarea">
                <textarea name="" id="" cols="30" rows="10"></textarea>
            </div>
            <div class="btn">
                <span @click="onClose">取消</span>
                <span @click="onClose" class="primary">发表</span>
            </div>
          </div>
        </div>
      </div>
    </popup>
  </transition>
</template>
<script>
import Popup from "./popup";
import browser from "@/utils/browser";


export default {
  name: "ui-tips",
  components: {
    Popup,
  },
  data() {
    return {
      show: false,
      isMobile: browser.mobile,
    };
  },
  methods: {
    onClose() {
      setTimeout(() => {
        this.show = false;
        document.body.removeChild(this.$el);
        this.$destroy();
      }, 0);
    },
  },
  mounted() {
    
  },
};
</script>
<style lang="less" scoped>
.ui-message-tips {
  position: absolute;
  left: 50%;
  top: 45%;
  background-color: #fff;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  max-width: 960px;
  z-index: 999;
  .ui-content {
    position: relative;
    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 28px;
      cursor: pointer;
      z-index: 999;
    }
    > h1 {
      color: #2e2e2e;
      font-size: 24px;
      text-align: center;
      padding: 30px 0;
    }
    .content {
      padding: 0 50px 30px;
      text-align: justify;
      line-height: 1.5;
      overflow: auto;
      max-height: 70vh;
      .textarea{
        border: rgba(43, 43, 43, 0.5) solid 1px;
        width: 580px;
        border-radius: 8px;
        overflow: hidden;
        >textarea{
          padding: 18px 22px;
          font-size: 18px;
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
        }
      }
      .btn{
          margin-top: 20px;
          text-align: right;
          span{
            display: inline-block;
            width: 120px;
            height: 48px;
            line-height: 48px;
            text-align: center;
            background: rgba(230, 199, 142, 0.1);
            border: 1px solid rgba(43, 43, 43, 0.5);
            opacity: 1;
            border-radius: 8px;
            margin-left: 20px;
            cursor: pointer;
          }
          .primary{
            background: #E6C78E;
            color: #fff;
            border: 1px solid #E6C78E;
          }
      }
    }
  }
  
}
@media screen and (max-width: 500px) {
  .ui-message-tips {
    width: 90%;
    .ui-content {
      position: relative;
      padding: 0;
      .close {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 24px;
        cursor: pointer;
      }
      > h1 {
        color: #2e2e2e;
        font-size: 16px;
        padding: 16px 0;
        text-align: center;
      }
      .content {
        text-align: justify;
        line-height: 1.5;
        margin-top: 0;
        margin-bottom: 22px;
        padding: 0 16px ;
        overflow: auto;
        .textarea{
            border: rgba(43, 43, 43, 0.5) solid 1px;
            width: 100%;
            height: 120px;
            >textarea{
                padding: 8px 10px;
                height: 120px;
                font-size: 16px;
            }
        }
        .btn{
          margin-top: 20px;
          text-align: right;
          font-size: 0;
          span{
            font-size: 0.88rem;
            display: inline-block;
            vertical-align: middle;
            width: 80px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            background: rgba(230, 199, 142, 0.1);
            border: 1px solid rgba(43, 43, 43, 0.5);
            border-radius: 8px;
            box-sizing: border-box;
            margin-left: 20px;
            cursor: pointer;
          }
          .primary{
            background: #E6C78E;
            color: #fff;
            border: 1px solid #E6C78E;
          }
      }
      }
    }
    .ui-map {
      min-width: unset;
      #map{
        width: 100%;
        height: 80vh;
        border-radius: 8px;
        overflow: hidden;
      }
    }
  }
}
</style>